/* cf-quote-cta.js - Click Fencing, 2026-09-01 (later session)
 *
 * Pete: "this button for instant quote doesnt look very modern or well fitting. fix it.
 *        also it would be nice if the add to cart was right next to it"
 *
 * WHAT WAS WRONG. Two separate problems that read as one.
 *
 * 1. THE QUOTE BOX LOOKED DATED. .final-quote-display renders as a hard rectangle -
 *    5px corners, flat #1a6b23, no padding of its own, the label and the amount stacked
 *    tight against the edges. Next to the rest of the page (cards at 8-14px radius with
 *    soft shadows) it reads like a leftover from an older build.
 *
 * 2. THE CALL TO ACTION WAS NOWHERE NEAR THE PRICE. The amount sits in
 *    .calculator-column-wide, while #add-to-cart lives in .calculator-navigation, a
 *    separate row further down and hard right. The customer reads the total in one place
 *    and then has to go looking for the way to act on it. Measured on a 6000mm flat top
 *    quote the two are in different containers entirely (no shared parent above
 *    .calculator-layout).
 *
 * WHAT THIS DOES. Wraps the quote display and the Add to Cart button in one flex row so
 * the price and the action sit together, and restyles the card to match the rest of the
 * site - 14px radius, real padding, a soft shadow, the label small and lettered, the
 * amount doing the shouting.
 *
 * The BACK button deliberately stays in .calculator-navigation. Only the primary action
 * moves; the secondary one belongs with the step controls.
 *
 * WHY THE BUTTON IS MOVED RATHER THAN DUPLICATED. A second button would mean two
 * elements with id="add-to-cart", and several things key off that id - the calculator's
 * own listener, _hideCheckoutUnlessReview(), cf-rake-height-assist.js, and the
 * unbuildable guard's historical selectors. Moving a node keeps its listeners and keeps
 * the id unique. _hideCheckoutUnlessReview still finds it by id and still hides it
 * outside the review step, so the step logic is untouched.
 *
 * Re-runs on mutation because the calculator rebuilds this column on every recalculation.
 * Idempotent - if the button is already in our row, nothing happens.
 *
 * Display only. No price, product, quantity or cart line is touched.
 */
(function () {
  'use strict';

  if (window.__cfQuoteCta) return;
  window.__cfQuoteCta = true;

  var CALC_PATHS = [
    '/pages/glass-fencing', '/pages/fence-calculator',
    '/pages/blade-fence-calculator', '/pages/flat-top-fence-calculator',
    '/pages/perfmesh-fence', '/pages/base-mount-batten-calculator'
  ];
  var path = (location.pathname || '/').replace(/\/+$/, '') || '/';
  if (CALC_PATHS.indexOf(path) === -1) return;

  var ROW_CLASS = 'cf-quote-cta-row';
  var STYLE_ID = 'cf-quote-cta-css';

  function css() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      '.' + ROW_CLASS + '{display:flex;align-items:stretch;gap:16px;flex-wrap:wrap;',
      '  margin:18px 0 6px;}',

      /* The price card. */
      '.' + ROW_CLASS + ' .final-quote-display{flex:1 1 260px;margin:0 !important;',
      '  background:linear-gradient(180deg,#1f7a34 0%,#15602a 100%) !important;',
      '  border-radius:14px !important;padding:18px 24px !important;',
      '  box-shadow:0 6px 18px rgba(14,68,30,.22) !important;',
      '  border:0 !important;display:flex;flex-direction:column;justify-content:center;',
      '  align-items:center;text-align:center;min-height:104px;}',
      '.' + ROW_CLASS + ' .final-quote-display .quote-label,',
      '.' + ROW_CLASS + ' .final-quote-display > div:not(.quote-amount){',
      '  color:#c7f0d2 !important;font-size:12px !important;font-weight:600 !important;',
      '  letter-spacing:.10em !important;text-transform:uppercase !important;',
      '  margin:0 0 4px !important;}',
      '.' + ROW_CLASS + ' .final-quote-display .quote-amount{',
      '  color:#fff !important;font-size:34px !important;line-height:1.1 !important;',
      '  font-weight:800 !important;letter-spacing:-.01em !important;}',

      /* The action, sitting right beside the number. */
      '.' + ROW_CLASS + ' #add-to-cart{flex:0 0 auto;align-self:stretch;',
      '  min-width:210px;min-height:104px;margin:0 !important;',
      '  border-radius:14px !important;border:0 !important;',
      '  font-size:18px !important;font-weight:700 !important;letter-spacing:.01em;',
      '  box-shadow:0 6px 18px rgba(150,20,20,.22);',
      '  transition:transform .12s ease, box-shadow .12s ease, filter .12s ease;',
      '  cursor:pointer;}',
      '.' + ROW_CLASS + ' #add-to-cart:hover{transform:translateY(-1px);',
      '  box-shadow:0 10px 24px rgba(150,20,20,.28);filter:brightness(1.04);}',
      '.' + ROW_CLASS + ' #add-to-cart:active{transform:translateY(0);}',

      /* Phones: stack, action full width and last. */
      '@media screen and (max-width:749px){',
      '  .' + ROW_CLASS + '{gap:12px;}',
      '  .' + ROW_CLASS + ' .final-quote-display{min-height:88px;padding:16px 18px !important;}',
      '  .' + ROW_CLASS + ' .final-quote-display .quote-amount{font-size:28px !important;}',
      '  .' + ROW_CLASS + ' #add-to-cart{width:100%;min-height:56px;}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  function apply() {
    try {
      var display = document.querySelector('.final-quote-display');
      var btn = document.getElementById('add-to-cart');
      if (!display || !btn) return;

      /* Already arranged - leave it alone so we do not fight the calculator's redraws. */
      var existing = display.parentElement;
      if (existing && existing.classList && existing.classList.contains(ROW_CLASS)) {
        if (btn.parentElement !== existing) existing.appendChild(btn);
        return;
      }

      css();

      var row = document.createElement('div');
      row.className = ROW_CLASS;
      display.parentNode.insertBefore(row, display);
      row.appendChild(display);
      row.appendChild(btn);
    } catch (e) {
      /* Display only - never let this interrupt the calculator. */
      if (window.console && console.debug) console.debug('[cf-quote-cta]', e);
    }
  }

  var scheduled = null;
  function schedule() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(apply, 120);
  }

  function start() {
    apply();
    try {
      var root = document.querySelector('.calculator-page') || document.body;
      if (window.MutationObserver) {
        new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      }
      window.addEventListener('resize', schedule);
    } catch (e) {}
    var n = 0;
    (function tick() { if (n++ > 40) return; apply(); setTimeout(tick, 500); })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
